import { connect } from 'react-redux'
import {insiderLoginInitiated} from 'modules/Insider/reducers/reducer';
import InsiderBenefits from '../components/InsiderBenefits'

const mapStateToProps = state => {

    let firstName = ''
    if (state.common.auth && state.common.auth.user && state.common.auth.user.firstname) {
        firstName = state.common.auth.user.firstname
    }
    
    return {
        loggedIn: state.common.auth.loggedIn,
        userFirstName: firstName
    }
}

const mapDispatchToProps = dispatch => {
    return {
        trackLoginClick: () => {
            dispatch(insiderLoginInitiated())
        },
        trackRegisterClick: () => {
            dispatch(insiderLoginInitiated())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InsiderBenefits)


// WEBPACK FOOTER //
// ./modules/Insider/containers/InsiderBenefits.js